<script>
export default {
  inject: ['isStepEnabled'],

  props: {
    formName: {
      type: String,
      required: true,
    },
    steps: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },

  emits: ['changeStep'],

  methods: {
    canChangeStep(step) {
      return step < this.currentStep && this.isStepEnabled(step);
    },

    getStepClasses(step) {
      return [
        'form-navigation__step',
        {
          'form-navigation__step--active': this.canChangeStep(step),
          'form-navigation__step--current': step === this.currentStep,
        },
      ];
    },

    changeStep(step) {
      if (this.canChangeStep(step)) {
        this.$emit('changeStep', { step, scrollToNavigation: false });
      }
    },
  },
};
</script>

<template>
  <section>
    <div class="container container--lg">
      <nav class="form-navigation">
        <ul class="form-navigation__steps">
          <li
            v-for="step in steps"
            :key="`form-nav-step-${step}`"
            :class="getStepClasses(step)"
            :data-cy="`form-nav-step-${step}`"
            @click.prevent="changeStep(step)"
          >
            <div class="form-navigation__step-count">{{ step }}</div>
            <div class="form-navigation__label">{{ $t(`Form.${formName}.step${step}.label`) }}</div>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>
